import React, { useContext, useState } from 'react'
import { LocaleContext } from '../routes'
import { ButtonScore, PurchaseText } from '../styles/button'
import { Content, WrapperBottomButton } from '../styles/elements'
import { UnPaidGiftBody } from '../styles/gift'
import Notification from './common/Notification'
import Button from './common/Button'
import Score from './Score'
import Confirm from './pay/Confirm'
import ShowPaidGift from './pay/ShowPaidGift'

export default ({
  id,
  price,
  score,
  expirationDate,
  description: {
    title,
    text,
    summary,
  },
  icon,
}) => {
  const locale = useContext(LocaleContext)

  const [shouldConfirmed, setShouldConfirmed] = useState()
  const [isBought, setBought] = useState()
  const [isError, setError] = useState()
  const [paidGift, setPaidGift] = useState()

  const showConfirmHint = () => setShouldConfirmed(true)
  const hideConfirmHint = () => setShouldConfirmed(false)

  const showBoughtHint = () => setBought(true)

  const showErrorNotification = () => setError(true)
  const isButtonDisabled = (price > score)

  const confirmProps = {
    setPaidGift,
    hideConfirmHint, showBoughtHint, showErrorNotification,
    title, icon, summary, price, id,
  }

  return (
    <UnPaidGiftBody id="gift-body">
      {isError &&
        <Notification type="error" />
      }
      <Content>
        {text}
      </Content>
      {expirationDate &&
        <Content>
          {locale.VOUCHER_EXPIRATION}: {locale.UNTIL_THE_END} {expirationDate}
        </Content>
      }
      <WrapperBottomButton>
        <Button
          text=""
          onClick={showConfirmHint}
          inactive={isButtonDisabled}
          errorMessage={isButtonDisabled && locale.INSUFFICIENT_STARS}
          pay={!isButtonDisabled}
        >
          <ButtonScore>
            <PurchaseText>{locale.PURCHASE}</PurchaseText>
            <Score status={"button " + (isButtonDisabled ? 'inactive' : 'active')}>
              {price}
            </Score>
          </ButtonScore>
        </Button>
      </WrapperBottomButton>

      {shouldConfirmed &&
        <Confirm {...confirmProps} />
      }

      {isBought &&
        <ShowPaidGift id={id} purchaseDate={paidGift && paidGift.purchaseDate} />
      }
    </UnPaidGiftBody>
  )
}
